const languageMap: { [key: string]: string } = {
  'en': 'en-us',
  'en-US': 'en-us', 
  'en-us': 'en-us', 
  'ja': 'ja-jp',
  'ja-JP': 'ja-jp',
  'ja-jp': 'ja-jp',
  'zh-tw': 'zh-tw',
  'zh-TW': 'zh-tw',
}

const defaultLang = 'zh-tw'

export { languageMap, defaultLang }
